import { api } from '../configs/apiConfig';

class WorkflowService {
    // Process Type Management
    async getAllProcessTypes() {
        const response = await api.get('/workflow/process-types');
        return response.data;
    }

    async getProcessTypeById(id) {
        const response = await api.get(`/workflow/process-types/${id}`);
        return response.data;
    }

    async createProcessType(createDTO) {
        const response = await api.post('/workflow/process-types', createDTO);
        return response.data;
    }

    async updateProcessType(id, updateDTO) {
        const response = await api.put(`/workflow/process-types/${id}`, updateDTO);
        return response.data;
    }

    async deleteProcessType(id) {
        await api.delete(`/workflow/process-types/${id}`);
    }

    // Workflow Template Management
    async getAllWorkflows() {
        const response = await api.get('/workflow/workflows');
        return response.data;
    }

    async getWorkflowsByProcessType(processTypeId) {
        const response = await api.get(`/workflow/workflows/by-process-type/${processTypeId}`);
        return response.data;
    }

    async getWorkflowById(id) {
        const response = await api.get(`/workflow/workflows/${id}`);
        return response.data;
    }

    async createWorkflow(createDTO) {
        const response = await api.post('/workflow/workflows', createDTO);
        return response.data;
    }

    async updateWorkflow(id, updateDTO) {
        const response = await api.put(`/workflow/workflows/${id}`, updateDTO);
        return response.data;
    }

    async setWorkflowAsDefault(id) {
        const response = await api.put(`/workflow/workflows/${id}/set-default`);
        return response.data;
    }

    async deleteWorkflow(id) {
        await api.delete(`/workflow/workflows/${id}`);
    }

    // Workflow Step Management
    async getWorkflowStepById(id) {
        const response = await api.get(`/workflow/steps/${id}`);
        return response.data;
    }

    async createWorkflowStep(createDTO) {
        const response = await api.post('/workflow/steps', createDTO);
        return response.data;
    }

    async updateWorkflowStep(id, updateDTO) {
        const response = await api.put(`/workflow/steps/${id}`, updateDTO);
        return response.data;
    }

    async reorderWorkflowStep(id, newOrder) {
        await api.put(`/workflow/steps/${id}/reorder`, newOrder);
    }

    async deleteWorkflowStep(id) {
        await api.delete(`/workflow/steps/${id}`);
    }

    // Step Approver Management
    async getStepApproverById(id) {
        const response = await api.get(`/workflow/approvers/${id}`);
        return response.data;
    }

    async createStepApprover(createDTO) {
        const response = await api.post('/workflow/approvers', createDTO);
        return response.data;
    }

    async updateStepApprover(id, updateDTO) {
        const response = await api.put(`/workflow/approvers/${id}`, updateDTO);
        return response.data;
    }

    async deleteStepApprover(id) {
        await api.delete(`/workflow/approvers/${id}`);
    }

    // Get workflows that use a workflow as a sub-workflow
    async getWorkflowsUsingAsSubWorkflow(workflowId) {
        const response = await api.get(`/workflow/${workflowId}/referenced-by`);
        return response.data;
    }

    // Error Handler
    handleError(error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Response error:', error.response.data);
            throw new Error(error.response.data.message || 'An error occurred');
        } else if (error.request) {
            // The request was made but no response was received
            console.error('Request error:', error.request);
            throw new Error('No response received from server');
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error:', error.message);
            throw new Error('Error setting up request');
        }
    }
}

// Create a singleton instance
const workflowService = new WorkflowService();

export default workflowService; 